import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable, map } from "rxjs";
import {
	type CreateLeadInput,
	type Inquiry,
	type Lead,
	Tour,
	type UpdateLeadInput,
} from "src/app/schema";
import { ApiService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class LeadsService {
	private readonly _api = inject(ApiService);
	private readonly _httpClient = inject(HttpClient);

	public createLead(lead: CreateLeadInput): Observable<Lead> {
		return this._httpClient
			.post<Lead>(`${this._api.communicationsApiEndpoint}/lead`, lead)
			.pipe(map((lead) => lead));
	}

	public updateLead(lead: UpdateLeadInput): Observable<Lead> {
		return this._httpClient
			.put<Lead>(`${this._api.communicationsApiEndpoint}/lead`, lead)
			.pipe(map((lead) => lead));
	}

	public assignLead(
		leadId: string,
		userId: string,
	): Observable<{ upcoming_tours: Tour[] }> {
		return this._httpClient
			.put<{ upcoming_tours: Tour[] }>(
				`${this._api.communicationsApiEndpoint}/lead/${leadId}/assign/${userId}`,
				{},
			)
			.pipe(map((response) => response));
	}

	public unassignLead(leadId: string): Observable<{ upcoming_tours: Tour[] }> {
		return this._httpClient
			.put<{ upcoming_tours: Tour[] }>(
				`${this._api.communicationsApiEndpoint}/lead/${leadId}/unassign`,
				{},
			)
			.pipe(map((response) => response));
	}

	public reassignUpcomingTours(
		leadId: string,
		userId: string,
	): Observable<{ upcoming_tours: Tour[] }> {
		return this._httpClient
			.put<{ upcoming_tours: Tour[] }>(
				`${this._api.communicationsApiEndpoint}/upcoming-tours/${leadId}/reassign/${userId}`,
				{},
			)
			.pipe(map((response) => response));
	}

	public readLead(leadId: string): Observable<Lead> {
		return this._httpClient
			.put<Lead>(
				`${this._api.communicationsApiEndpoint}/lead/${leadId}/read`,
				{},
			)
			.pipe(map((lead) => lead));
	}

	public archiveLead(leadId: string): Observable<Lead> {
		return this._httpClient
			.put<Lead>(
				`${this._api.communicationsApiEndpoint}/lead/${leadId}/archive`,
				{},
			)
			.pipe(map((lead) => lead));
	}

	public getInquiry(inquiryId: string): Observable<Inquiry> {
		return this._httpClient
			.get<Inquiry>(
				`${this._api.communicationsApiEndpoint}/inquiry/${inquiryId}`,
			)
			.pipe(map((inquiry) => inquiry));
	}
}
